module.exports = {
  validateSeal: require('./validator/index'),
  generateSealsInterval: require('./generator/index'),
  findCheckDigit: require('./predict-digit/index')
}
